import { useTheme } from '@emotion/react'
import { Box, Grid } from '@mui/material'
import { FetchAllStartupProfileViews } from 'api/org/startups'
import React from 'react'
import { useSelector } from 'react-redux'
import AsyncTableListing from 'ui-components/AsyncTableListing'
import placeHolderImage from "assets/no_data_images/no_data_feedbacks_views.svg"
import Cookies from 'js-cookie'

const ViewProfile = () => {
  const theme = useTheme()
  let [startup_id, setStartupID] = React.useState(Cookies.get("startup_id") || null);
  const column = [
    { Header: 'Name', accessor: 'name', minWidth: 150, align: 'start', fixed: true },
    { Header: 'City, Country',accessor: 'location', minWidth: 150, align: 'center' },
    { Header: 'Times Viewed', accessor: 'view_times', minWidth: 150, align: 'center' },
    { Header: 'Last Viewed', accessor: 'formatted_date', minWidth: 150, align: 'center' },

  ];

  const [page, setPage] = React.useState(1);
  const [limit, setLimit] = React.useState(10);
  const [sort, setSort] = React.useState(-1);
  const [search, setSearch] = React.useState(-1);

  // const data = [
  //     { 
  //     //   name: 'John Doe', 
  //       location: 'New York, USA', 
  //       date: '01-JAN-2024', 
  //       email: 'john.doe@example.com' 
  //     },
  //     { 
  //       name: 'Jane Smith', 
  //       location: 'Los Angeles, USA', 
  //       date: '15-FEB-2024', 
  //     //   email: 'jane.smith@example.com' 
  //     },
  //     { 
  //     //   name: 'Michael Johnson', 
  //       location: 'Chicago, USA', 
  //       date: '22-MAR-2024', 
  //       email: 'michael.johnson@example.com' 
  //     },
  //     { 
  //       name: 'Emily Davis', 
  //       location: 'Houston, USA', 
  //       date: '10-APR-2024', 
  //     //   email: 'emily.davis@example.com' 
  //     },
  //     { 
  //       // No name here
  //       location: 'Phoenix, USA', 
  //       date: '05-MAY-2024', 
  //       email: 'william.brown@example.com' 
  //     },
  //     { 
  //       name: 'Sophia Wilson', 
  //       location: 'Jaipur, INDIA', 
  //       date: '18-JUN-2024', 
  //     //   email: 'sophia.wilson@example.com' 
  //     },
  //     { 
  //       name: 'James Martinez', 
  //       location: 'Delhi, INDIA', 
  //       date: '08-JUL-2024', 
  //     //   email: 'james.martinez@example.com' 
  //     },
  //     { 
  //       // No name here
  //       location: 'Mumbai, INDIA', 
  //       date: '30-AUG-2024', 
  //       email: 'olivia.garcia@example.com' 
  //     },
  //     { 
  //       name: 'Benjamin Rodriguez', 
  //       location: 'Bangalore, INDIA', 
  //       date: '12-SEP-2024', 
  //     //   email: 'benjamin.rodriguez@example.com' 
  //     },
  //     { 
  //       // No name here
  //       location: 'Kolkata, INDIA', 
  //       date: '01-OCT-2024', 
  //       email: 'emma.martinez@example.com' 
  //     }
  //   ];


  // const { data: profileViewsData, isLoading: isLoadingProfileViews, mutateAsync: mutateAsyncProfileViews } = FetchAllStartupProfileViews()
  const { data: profileViewsData, isLoading: isLoadingProfileViews, isRefetching } = FetchAllStartupProfileViews({ id: startup_id, page, limit, sort })

  const formattedProfileViewsData = profileViewsData?.data && profileViewsData?.data?.length ? profileViewsData?.data : []


  return (
    <>
      <Grid container xs={12} pt={2} pb={0} spacing={2} display={"flex"} justifyContent={"space-between"} marginLeft={0} alignContent={"flex-start"} >
        {isLoadingProfileViews && isRefetching == false ?
          <Grid item xs={12} height={"100vh"} sx={{ width: '100%', padding: "2rem", paddingLeft: "2rem !important", paddingTop: "0rem !important", bgColor: theme.palette.customColors.yellow_bg }} paddingInline={{ xs: "0.5rem !important", sm: '1rem !important', md: '1rem !important', lg: '2rem !important' }}>
            <Box className='skeleton' minHeight={"70vh"} sx={{ borderRadius: "8px", border: `1px solid ${theme.palette.customColors.b50}` }} marginTop={0}>

            </Box>
          </Grid>
          :
          <Box width={"100%"} paddingLeft={"2rem"} maxWidth={"100%"} overflow={"hidden"} paddingInline={{ xs: "0.5rem !important", sm: '1rem !important', md: '1rem !important', lg: '2rem !important' }}>
            <AsyncTableListing
              // isLoading={isLoadingProfileViews}
              columns={column}
              data={formattedProfileViewsData}
              page={page}
              setPage={setPage}
              limit={profileViewsData?.limit}
              setLimit={setLimit}
              count={profileViewsData?.count}
              noDataPlaceHolderImage={placeHolderImage}
              noDataTitle='No Profile Views'
              noDataSubTitle='It seems like there are no views available at the moment.'
              noDataPlaceHolderSx={{ width: 300 }}
              // tabValue={value}
              // data={[]}
              // title={"Investors"}
              // chipText={`${data?.length}${isSmallScreen ? "" : " Investors"}`}
              // actions={Actions}
              // RowActions={RowActions}
              sx={{ borderRadius: '8px', border: profileViewsData?.length > 0 ? `1px solid ${theme.palette.customColors.b50}` : "none", bgcolor: profileViewsData?.length > 0 ? "white" : "transparent" }}
            // refetchListing={refetchListing}
            />
          </Box>
        }

        {/* </Grid>} */}
        {/* <Grid item xs={2} lg={2}> */}

      </Grid>
    </>
  )
}

export default ViewProfile
